/**
 * 将数组转换为对象，使用数组项的指定字段作为键和值
 * @param {Array} arr - 输入的数组
 * @param {Object} config - 配置对象
 * @param {string} config.key - 作为键的字段名，默认为 'value'
 * @param {string} config.value - 作为值的字段名，默认为 'label'
 * @returns {Object} - 转换后的对象
 */
export const listToMap = (arr = [], config = {}) => {
    const { key = 'value', value = 'label' } = config;
    const result = {};
    // 遍历数组，将每一项的指定字段作为键值对添加到结果对象中
    arr.forEach(item => {
        if (item[key] !== undefined && item[value] !== undefined) {
            result[item[key]] = item[value] ?? '';
        }
    });
    return result;
}

/**
 * 下载Excel文件（需携带登录 token 与租户头，多租户模式下才能正常导出）
 * @param {string} url - 下载接口完整地址
 * @param {string} token - 认证 token
 * @param {Object} [params={}] - 查询参数
 * @param {string} [filename='download.xlsx'] - 保存文件名
 * @param {{ tenantId?: string|number }} [options={}] - 额外请求头
 * @returns {Promise<boolean>} 是否下载成功
 */
export const downloadExcel = (url, token, params = {}, filename = 'download.xlsx', options = {}) => {
    const queryString = Object.keys(params)
        .filter((key) => params[key] != null && params[key] !== '')
        .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
        .join('&')
    const requestUrl = queryString ? `${url}?${queryString}` : url
    const authHeader = token && String(token).startsWith('Bearer ') ? token : `Bearer ${token}`

    return new Promise((resolve) => {
        const xhr = new XMLHttpRequest()
        xhr.open('GET', requestUrl, true)
        xhr.setRequestHeader('Authorization', authHeader)
        if (options.tenantId != null && options.tenantId !== '') {
            xhr.setRequestHeader('X-Tenant-Id', String(options.tenantId))
        }
        xhr.responseType = 'blob'

        xhr.onload = function () {
            if (this.status === 200 && this.response && this.response.size > 0) {
                const contentType = this.getResponseHeader('content-type') || 'application/vnd.ms-excel'
                const blob = new Blob([this.response], { type: contentType })
                const downloadUrl = URL.createObjectURL(blob)
                const a = document.createElement('a')
                a.href = downloadUrl
                a.download = filename
                document.body.appendChild(a)
                a.click()
                setTimeout(() => {
                    document.body.removeChild(a)
                    URL.revokeObjectURL(downloadUrl)
                }, 100)
                resolve(true)
                return
            }
            console.error('下载失败:', this.status, this.statusText)
            resolve(false)
        }

        xhr.onerror = function () {
            console.error('请求失败')
            resolve(false)
        }

        xhr.send()
    })
}

export const timestampToYMDhms = (timestamp) => {
    if(!timestamp) {
        return ''
    }
    let date = new Date(timestamp) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear()
    let M =
        (date.getMonth() + 1 < 10 ?
            '0' + (date.getMonth() + 1) :
            date.getMonth() + 1)
    let D =
        (date.getDate() < 10 ? '0' + date.getDate() : date.getDate())
    let h =
        (date.getHours() < 10 ? '0' + date.getHours() : date.getHours())
    let m =
        (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes())
    let s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
    return `${Y}-${M}-${D} ${h}:${m}:${s}`
}


export const timestampToYMD = (timestamp) => {
    if(!timestamp) {
        return ''
    }
    let date = new Date(timestamp) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear()
    let M =
        (date.getMonth() + 1 < 10 ?
            '0' + (date.getMonth() + 1) :
            date.getMonth() + 1)
    let D =
        (date.getDate() < 10 ? '0' + date.getDate() : date.getDate())
    let h =
        (date.getHours() < 10 ? '0' + date.getHours() : date.getHours())
    let m =
        (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes())
    let s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
    return `${Y}-${M}-${D}`
}


export const getLastDayOfCurrMonth = (str) => {
  const date = new Date();
  const year = date.getFullYear();
  const month = date.getMonth();

  // 下个月的第0天就是当前月的最后一天
  const lastDay = new Date(year, month + 1, 0);

  return {
    day: lastDay.getDate(),       // 最后一天的日期
    weekday: lastDay.getDay(),     // 星期几（0-6）
    fullDate: lastDay             // 完整的Date对象
  };
}

export const getLastDayOfMonth = (yearMonth) => {
  const [year, month] = yearMonth.split('-').map(Number);
  const lastDay = new Date(year, month, 0);

  // 使用 toISOString 并调整格式
  return lastDay.toISOString().split('T')[0];
}